import { render, staticRenderFns } from "./New.vue?vue&type=template&id=6a3e565e&scoped=true&"
import script from "./New.vue?vue&type=script&lang=ts&"
export * from "./New.vue?vue&type=script&lang=ts&"
import style0 from "./New.vue?vue&type=style&index=0&id=6a3e565e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3e565e",
  null
  
)

export default component.exports